import { gql } from '@apollo/client';

export const GET_USER_NOTIFICATIONS = gql`
    query GetUserNotifications($filters: NotificationFilters, $pagination: PaginationInput) {
        getUserNotifications(filters: $filters, pagination: $pagination) {
            notifications {
                message {
                    id
                    priority
                    message
                    tenantId
                    createdAt
                }
                userId
                roleId
                receivedAt
                readAt
                hide
                important
                module
                relatedCount
                pinned
                muted
            }
            unreadCount
            total
        }
    }
`;

export const GET_UNREAD_COUNT = gql`
    query GetUnreadCount {
        getUnreadCount
    }
`;
